<template>
  <div class="corrugated-carton-boxes with-slider">
    <!--type slider (desktop)-->
    <slider-select
      v-if="fields[CorrugatedCartonBoxesFields.type].options?.length"
      v-model="form.type"
      class="main-slider"
    >
      <slider-select-option
        v-for="option in fields[CorrugatedCartonBoxesFields.type].options"
        :key="option.value"
        :value="option.value"
        :label="option.title"
        :image-src="uploadsUrl(option?.thumbnail?.data?.attributes.url || '')"
      />
    </slider-select>
    <i-form
      v-scroll-to-invalid
      class="form"
      name="corrugated-carton-boxes-form"
      @submit="handleSubmit"
    >
      <div class="type">
        <strapi-label
          v-if="labels[CorrugatedCartonBoxesLabels.type]"
          :label="labels[CorrugatedCartonBoxesLabels.type]"
        />
        <div class="form-field-group">
          <!--type field-->
          <zaproo-select
            v-if="fields[CorrugatedCartonBoxesFields.type]"
            v-model="form.type"
            :removable="false"
            searchable
            highlight
            :no-result-label="$t('No results found')"
            no-result-class="text-neutral-900/50 text-center !py-2 !px-4"
            name="type"
            :rules="fieldRules[CorrugatedCartonBoxesFields.type]"
            :placeholder="$t('Select option')"
            dropdown-classes="py-2 mt-2"
            class="form-field checkmark"
          >
            <template #label>
              <special-order-form-input-label
                :field="fields[CorrugatedCartonBoxesFields.type]"
              />
            </template>

            <zaproo-select-option
              v-for="option in fields[CorrugatedCartonBoxesFields.type].options"
              :key="option.value"
              :value="option.value"
              :label="option.title"
            />
          </zaproo-select>
        </div>
        <div class="form-field-group">
          <zaproo-file-input
            v-if="
              isSelectOtherType && fields[CorrugatedCartonBoxesFields.typeFile]
            "
            v-model="form.typeFile"
            class="mt-3"
            name="typeFiles"
            :rules="fieldRules[CorrugatedCartonBoxesFields.typeFile]"
            multiple
            :total-size-of-files="INPUT_FILE_TOTAL_SIZE"
            :placeholder="
              fields[CorrugatedCartonBoxesFields.typeFile].placeholder
            "
            file-item-classes="h-10"
            remove-button-classes="!p-0"
          >
            <template #label>
              <special-order-form-input-label
                :field="fields[CorrugatedCartonBoxesFields.typeFile]"
              />
            </template>
            <template #removeFileText>
              <icons-icon-trash />
              {{ $t("Remove") }}
            </template>
            <template #fileError="{ errors, clear }">
              <div class="mb-2 grid grid-cols-1 gap-2">
                <file-input-error-notification
                  :clear="clear"
                  :errors="errors"
                />
              </div>
            </template>
          </zaproo-file-input>
        </div>
      </div>

      <!--type slider (max to desktop)-->
      <div
        v-if="fields[CorrugatedCartonBoxesFields.type].options?.length"
        class="form-slider"
      >
        <slider-select v-model="form.type">
          <slider-select-option
            v-for="option in fields[CorrugatedCartonBoxesFields.type].options"
            :key="option.value"
            :value="option.value"
            :label="option.value"
            :image-src="
              uploadsUrl(option?.thumbnail?.data?.attributes.url || '')
            "
          />
        </slider-select>
      </div>

      <div class="dimensions mt-6">
        <strapi-label
          v-if="labels[CorrugatedCartonBoxesLabels.dimensions]"
          :label="labels[CorrugatedCartonBoxesLabels.dimensions]"
        />
        <div class="form-field-third">
          <zaproo-input
            v-if="fields[CorrugatedCartonBoxesFields.length]"
            v-model="form.length"
            type="number"
            name="length"
            :rules="fieldRules[CorrugatedCartonBoxesFields.length]"
            :placeholder="
              fields[CorrugatedCartonBoxesFields.length].placeholder
            "
            :description="
              fields[CorrugatedCartonBoxesFields.length].description
            "
            class="form-field"
          >
            <template #label>
              <special-order-form-input-label
                :field="fields[CorrugatedCartonBoxesFields.length]"
              />
            </template>
          </zaproo-input>

          <zaproo-input
            v-if="fields[CorrugatedCartonBoxesFields.width]"
            v-model="form.width"
            type="number"
            name="width"
            :rules="fieldRules[CorrugatedCartonBoxesFields.width]"
            :placeholder="fields[CorrugatedCartonBoxesFields.width].placeholder"
            :description="fields[CorrugatedCartonBoxesFields.width].description"
            class="form-field"
          >
            <template #label>
              <special-order-form-input-label
                :field="fields[CorrugatedCartonBoxesFields.width]"
              />
            </template>
          </zaproo-input>

          <zaproo-input
            v-if="fields[CorrugatedCartonBoxesFields.height]"
            v-model="form.height"
            type="number"
            name="height"
            :rules="fieldRules[CorrugatedCartonBoxesFields.height]"
            :placeholder="
              fields[CorrugatedCartonBoxesFields.height].placeholder
            "
            :description="
              fields[CorrugatedCartonBoxesFields.height].description
            "
            class="form-field"
          >
            <template #label>
              <special-order-form-input-label
                :field="fields[CorrugatedCartonBoxesFields.height]"
              />
            </template>
          </zaproo-input>
        </div>
      </div>

      <div class="material mt-6">
        <strapi-label
          v-if="labels[CorrugatedCartonBoxesLabels.material]"
          :label="labels[CorrugatedCartonBoxesLabels.material]"
        />
        <div
          :class="[isOtherMaterial ? 'form-field-third' : 'form-field-group']"
        >
          <!--material field-->
          <zaproo-select
            v-if="fields[CorrugatedCartonBoxesFields.material]"
            v-model="form.material"
            :removable="false"
            name="material"
            :rules="fieldRules[CorrugatedCartonBoxesFields.material]"
            :placeholder="$t('Select option')"
            dropdown-classes="py-2 mt-2"
            class="form-field checkmark"
          >
            <template #label>
              <special-order-form-input-label
                :field="fields[CorrugatedCartonBoxesFields.material]"
              />
            </template>

            <zaproo-select-option
              v-for="option in fields[CorrugatedCartonBoxesFields.material]
                .options"
              :key="option.value"
              :value="option.value"
              >{{ option.title }}</zaproo-select-option
            >
          </zaproo-select>

          <!--other material field-->
          <zaproo-input
            v-if="
              isOtherMaterial &&
              fields[CorrugatedCartonBoxesFields.otherMaterial]
            "
            v-model="form.otherMaterial"
            type="text"
            f
            name="otherMaterial"
            :rules="fieldRules[CorrugatedCartonBoxesFields.otherMaterial]"
            :placeholder="
              fields[CorrugatedCartonBoxesFields.otherMaterial].placeholder
            "
            :description="
              fields[CorrugatedCartonBoxesFields.otherMaterial].description
            "
            class="form-field"
          >
            <template #label>
              <special-order-form-input-label
                :field="fields[CorrugatedCartonBoxesFields.otherMaterial]"
              />
            </template>
          </zaproo-input>

          <!--mainColor field-->
          <zaproo-select
            v-if="fields[CorrugatedCartonBoxesFields.mainColor]"
            v-model="form.mainColor"
            :removable="false"
            name="mainColor"
            :rules="fieldRules[CorrugatedCartonBoxesFields.mainColor]"
            :placeholder="$t('Select option')"
            dropdown-classes="py-2 mt-2"
            class="form-field checkmark"
          >
            <template #label>
              <special-order-form-input-label
                :field="fields[CorrugatedCartonBoxesFields.mainColor]"
              />
            </template>

            <zaproo-select-option
              v-for="option in fields[CorrugatedCartonBoxesFields.mainColor]
                .options"
              :key="option.value"
              :value="option.value"
              >{{ option.title }}</zaproo-select-option
            >
          </zaproo-select>
        </div>
      </div>

      <div class="print mt-6">
        <strapi-label
          v-if="labels[CorrugatedCartonBoxesLabels.print]"
          :label="labels[CorrugatedCartonBoxesLabels.print]"
        />
        <div class="form-field-group">
          <div>
            <!--numberOfPrintColors field-->
            <zaproo-select
              v-if="fields[CorrugatedCartonBoxesFields.numberOfPrintColors]"
              v-model="form.numberOfPrintColors"
              :removable="false"
              :rules="
                fieldRules[CorrugatedCartonBoxesFields.numberOfPrintColors]
              "
              :placeholder="$t('Select option')"
              dropdown-classes="py-2 mt-2"
              name="numberOfPrintColors"
              class="form-field checkmark"
            >
              <template #label>
                <special-order-form-input-label
                  :field="
                    fields[CorrugatedCartonBoxesFields.numberOfPrintColors]
                  "
                />
              </template>

              <zaproo-select-option
                v-for="option in fields[
                  CorrugatedCartonBoxesFields.numberOfPrintColors
                ].options"
                :key="option.value"
                :value="option.value"
                >{{ option.title }}</zaproo-select-option
              >
            </zaproo-select>

            <!--designFile field-->
            <zaproo-file-input
              v-if="
                isPrintDesignFile &&
                fields[CorrugatedCartonBoxesFields.designFile]
              "
              v-model="form.designFile"
              class="mt-3"
              name="designFiles"
              :rules="fieldRules[CorrugatedCartonBoxesFields.designFile]"
              multiple
              :total-size-of-files="INPUT_FILE_TOTAL_SIZE"
              :placeholder="
                fields[CorrugatedCartonBoxesFields.designFile].placeholder
              "
              file-item-classes="h-10"
              remove-button-classes="!p-0"
            >
              <template #label>
                <special-order-form-input-label
                  :field="fields[CorrugatedCartonBoxesFields.designFile]"
                />
              </template>
              <template #removeFileText>
                <icons-icon-trash />
                {{ $t("Remove") }}
              </template>
              <template #fileError="{ errors, clear }">
                <div class="mb-2 grid grid-cols-1 gap-2">
                  <file-input-error-notification
                    :clear="clear"
                    :errors="errors"
                  />
                </div>
              </template>
            </zaproo-file-input>
          </div>
        </div>
      </div>

      <special-order-form-general-contacts-part
        v-model="form"
        class="general-contacts-form"
        :loading="loading"
      >
        <zaproo-input
          v-if="fields[CorrugatedCartonBoxesFields.amountPcs]"
          v-model="form.amountPcs"
          type="number"
          name="amountPcs"
          :rules="fieldRules[CorrugatedCartonBoxesFields.amountPcs]"
          :placeholder="
            fields[CorrugatedCartonBoxesFields.amountPcs].placeholder
          "
          :description="
            fields[CorrugatedCartonBoxesFields.amountPcs].description
          "
          class="form-field"
        >
          <template #label>
            <special-order-form-input-label
              :field="fields[CorrugatedCartonBoxesFields.amountPcs]"
            />
          </template>
        </zaproo-input>
      </special-order-form-general-contacts-part>
    </i-form>
  </div>
</template>

<script setup lang="ts">
import { Form as IForm, FormActions } from "vee-validate";
import SpecialOrderFormInputLabel from "../SpecialOrderFormInputLabel.vue";
import {
  CorrugatedCartonBoxesLabels,
  CorrugatedCartonBoxesFields,
} from "./types";
import type {
  StrapiField,
  StrapiLabel as StrapiLabelType,
  StrapiSpecialOrders,
} from "~/types/strapi";

import { getFieldDefaultModel } from "~/modules/special-orders/helpers";

import StrapiLabel from "~/components/strapi/components/shared/StrapiLabel.vue";
import SliderSelect from "~/modules/special-orders/components/SliderSelect/SliderSelect.vue";
import SliderSelectOption from "~/modules/special-orders/components/SliderSelect/SliderSelectOption.vue";
import { INPUT_FILE_TOTAL_SIZE } from "~/modules/special-orders/variables";
import FileInputErrorNotification from "~/modules/special-orders/components/SpecialOrderForm/FileInputErrorNotification.vue";
import { useFormFieldCleaner } from "~/modules/special-orders/composables/useFormFieldCleaner";

const props = defineProps<{
  specialOrder: StrapiSpecialOrders;
}>();

const { uploadsUrl } = useStrapiExtend();

const { collection: labelCollection } =
  useSpecialOrderUidDictionary<StrapiLabelType>(props.specialOrder.labels);

const { collection: fieldsCollection } =
  useSpecialOrderUidDictionary<StrapiField>(props.specialOrder.fields);

const { sendRequest, loading } = useSpecialOrdersSubmit(props.specialOrder);

const labels = computed(() => labelCollection(CorrugatedCartonBoxesLabels));
const fields = computed(() => fieldsCollection(CorrugatedCartonBoxesFields));
const fieldRules = useSpecialOrderFieldRules<
  typeof CorrugatedCartonBoxesFields
>(fields.value);

const form = ref<ReturnType<typeof resetForm>>(resetForm());

const isPrintDesignFile = computed<boolean>(
  () => form.value.numberOfPrintColors !== "no-print",
);
const isSelectOtherType = computed<boolean>(() => form.value.type === "other");

const isOtherMaterial = computed<boolean>(
  () => form.value.material === "other",
);

function resetForm() {
  return {
    type: getFieldDefaultModel(fields.value[CorrugatedCartonBoxesFields.type]),
    length: getFieldDefaultModel(
      fields.value[CorrugatedCartonBoxesFields.length],
    ),
    width: getFieldDefaultModel(
      fields.value[CorrugatedCartonBoxesFields.width],
    ),
    height: getFieldDefaultModel(
      fields.value[CorrugatedCartonBoxesFields.height],
    ),
    material: getFieldDefaultModel(
      fields.value[CorrugatedCartonBoxesFields.material],
    ),
    otherMaterial: getFieldDefaultModel(
      fields.value[CorrugatedCartonBoxesFields.otherMaterial],
    ),
    mainColor: getFieldDefaultModel(
      fields.value[CorrugatedCartonBoxesFields.mainColor],
    ),
    numberOfPrintColors: getFieldDefaultModel(
      fields.value[CorrugatedCartonBoxesFields.numberOfPrintColors],
    ),
    amountPcs: getFieldDefaultModel(
      fields.value[CorrugatedCartonBoxesFields.amountPcs],
    ),
    designFile: [],
    typeFile: [],
    email: "",
    phone: "",
    additionalInfo: "",
  };
}

async function handleSubmit(
  _: Record<string, unknown>,
  { resetForm: reset }: FormActions<Record<string, unknown>>,
) {
  await sendRequest(form.value);
  reset();
  form.value = resetForm();
}

useFormFieldCleaner(
  {
    typeFile: {
      default: () => [],
      ref: isSelectOtherType,
    },
    designFile: {
      default: () => [],
      ref: isPrintDesignFile,
    },
    otherMaterial: {
      default: () =>
        getFieldDefaultModel(
          fields.value[CorrugatedCartonBoxesFields.otherMaterial],
        ),
      ref: isOtherMaterial,
    },
  },
  form,
);
</script>
